import { DEFAULT_CHARACTER } from '@shared/index'
import { createFileRoute } from '@tanstack/react-router'

import PageCostTracking from '../pages/PageCostTracking'

type CostTrackingSearch = {
  character: string
}

export const Route = createFileRoute('/settings/cost-tracking')({
  component: PageCostTracking,
  validateSearch: (search: Record<string, unknown>): CostTrackingSearch => ({
    character: (search.character as string) || DEFAULT_CHARACTER
  })
})
